import dynamic from "next/dynamic";

export const ContentList = dynamic(() => import("./component"));
